//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { OverlayIconButton } from '@components/atoms/button/Button';
import { ImageWithErrorHandling } from '@components/atoms/image-with-error-handling/ImageWithErrorHandling';

interface VariantImagePreviewProps {
  alt: string;
  isViewOnly: boolean;
  onRemove: () => void;
  src: string | undefined;
}

export const VariantImagePreview = ({
  alt,
  isViewOnly,
  onRemove,
  src,
}: VariantImagePreviewProps) => {
  return (
    <PreviewContainer>
      <PreviewImage alt={alt} src={src} />
      {!isViewOnly && (
        <StyledOverlayIconButton
          aria-label='Remove image'
          iconName='delete'
          onClick={onRemove}
        />
      )}
    </PreviewContainer>
  );
};

const PreviewContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100px;
    height: 100px;
    background-color: ${theme.colors.gray1};
    border-radius: ${theme.borderRadii[1]};
    overflow: hidden;
  `}
`;

const PreviewImage = styled(ImageWithErrorHandling)`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border: 1px solid ${theme.colors.gray2};
    border-radius: ${theme.borderRadii[2]};
    object-fit: contain;
  `}
`;

const StyledOverlayIconButton = styled(OverlayIconButton)`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spacings[1]};
    left: ${theme.spacings[1]};
  `}
`;
